import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const selectionToolbarPluginKey = new PluginKey('selectionToolbarPluginKey');
